import * as React from 'react';
import ReactDOM from 'react-dom';

import { FlameTheme } from '@lightspeed/flame/Core';
import { IconInfo } from '@lightspeed/flame/Icon/Info';

import AlertMessageDisplay from 'root/apps/components/AlertMessageDisplay/AlertMessageDisplay';
import { DiscountMethod } from 'root/apps/PurchaseOrder/LandedCostControl/types';

interface DiscountHelpDisplayProps {
  discountHelpDisplay: HTMLDivElement | null;
  discountMethod: DiscountMethod;
  status: string | undefined;
}

export const DiscountHelpDisplay: React.FC<DiscountHelpDisplayProps> = ({
  discountHelpDisplay,
  discountMethod,
  status,
}) => {
  if (!discountHelpDisplay) return null;

  if (discountMethod === 'manually' && status !== 'finished') {
    discountHelpDisplay.classList.remove('hidden');
  } else {
    discountHelpDisplay.classList.add('hidden');
  }
  discountHelpDisplay.style.height = 'auto';
  discountHelpDisplay.style.padding = '6px';

  return ReactDOM.createPortal(
    <FlameTheme>
      <AlertMessageDisplay
        alertMessage={{
          type: 'info',
          message:
            'Add discount to specific items in the input field on the table and refresh the page to see the discount total in order costs.',
        }}
        noCloseBtn={true}
        noBorderTop={true}
        icon={<IconInfo baseColor="none" detailsColor="#000" />}
        data-test="discount-help-display"
      />
    </FlameTheme>,
    discountHelpDisplay
  );
};
